import {
  ExitToAppOutlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from '@rossum/ui/icons';
import {
  IconAsterisk,
  IconCustomAsteriskOff,
  IconCustomExportOff,
} from '@rossum/ui/icons/tabler';
import { SvgIcon } from '@rossum/ui/material';
import { FieldsFormModel } from '../../form-model/formModels';

export type QuickActionField = keyof Pick<
  FieldsFormModel['field'],
  'exported' | 'hidden' | 'required'
>;

const icons = {
  hidden: {
    on: VisibilityOutlined,
    off: VisibilityOffOutlined,
  },
  exported: {
    on: ExitToAppOutlined,
    off: IconCustomExportOff,
  },
  required: {
    on: IconAsterisk,
    off: IconCustomAsteriskOff,
  },
};

type QuickActionIconProps = {
  fieldKey: QuickActionField;
  state: boolean;
  disabled?: boolean;
};

export const QuickActionIcon = ({
  fieldKey,
  state,
  disabled,
}: QuickActionIconProps) => {
  const Icon = icons[fieldKey][state ? 'on' : 'off'];

  return (
    <SvgIcon
      fontSize="small"
      color={disabled ? 'disabled' : state ? 'success' : 'action'}
    >
      <Icon />
    </SvgIcon>
  );
};
